import { useEffect } from 'react';
export const useHome = props => {
    const {fetchOtherdetails,otherdetails} =props
    useEffect(()=>{
        if(!otherdetails||otherdetails.length ==0)
        fetchOtherdetails()
      },[otherdetails])
}